import { mapMutations } from 'vuex'
export const Login = {
  data () {
    return {
      tel: '',
      code: '',
      isTelFocus: false,
      isCodeFocus: false,
      send_code:'发送验证码',
      send_code_status:true,
      send_code_time:59
    }
  },
  methods: {
    ...mapMutations({
      setIsLogin: 'setIsLogin'
    }),
    send_code_fn:function(){
        var that=this;
        if(that.send_code_status){
            var timer=setInterval(function(){
                var send_code_time=that.send_code_time--;
                if(send_code_time<=0){
                    clearInterval(timer);
                    that.send_code_time=59;
                    that.send_code_status=true;
                    that.send_code='发送验证码';
                    return;
                }
                that.send_code=send_code_time+'秒';
            },1000);
            that.send_code_status=false;
        }
    },
    get_code:function(){
        var that=this;
        if (that.tel=='') {         
            alert('请输入手机号');           
            return;
        } 
        if (!/^1[3|4|5|8|7|9]{1}\d{9}$/.test(that.tel)) {
            alert('手机号码不正确，请重新输入正确的手机号');
            return;
        }
        this.$http.get(that.$root.apiBaseUrl + '?g=api&m=api&a=web_send_code_api',{
                params:{
                    is_web:1,
                    mobile:that.tel
                }
            }).then(function(res){
            if(res.data.status==1){
                that.send_code_fn();
            }else{
                alert(res.data.message);
            }
        },function(){
            alert('请求失败');
        });
    },
    login:function(){
        var that=this;
        if(that.tel== ''){                   
            alert('请输入手机号');
            return;
        }
        if (!/^1[3|4|5|8|7|9]{1}\d{9}$/.test(that.tel)) {
            alert('手机号码不正确，请重新输入正确的手机号');
            return;
        }
        if(that.code==''){           
           alert('请输入验证码');
            return;
        }
        this.$http.get(that.$root.apiBaseUrl + '?g=api&m=api&a=web_login_api',{
                params:{
                    is_web:1,
                    mobile:that.tel,
                    code:that.code
                }
            }).then(function(res){

            if(res.data.status==1){
                var user_token=res.data.data.user_token;
                window.localStorage.setItem('user_token',user_token);
                that.send_code_time=59;
                that.send_code_status=true;
                that.send_code='发送验证码';

                // 登录成功
                console.log('login ok');
                that.setIsLogin(true);
                var redirect = this.$route.query.redirect ? this.$route.query.redirect : '/index';
                that.$router.push(redirect);
                
            }else{
                alert(res.data.message);
            }

        },function(){

            alert('请求失败');

        });

    }

  }
}